// extracted by mini-css-extract-plugin
export var closeButton = "_1a-1";
export var container = "_1a-0";
export var fullModalImage = "_1a-2";